module.exports = __webpack_public_path__ + "static/media/social-media-2.facb1a02.png";